import { render, staticRenderFns } from "./SpecialOfferForm.vue?vue&type=template&id=06a516d5&scoped=true&"
import script from "./SpecialOfferForm.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferForm.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferForm.vue?vue&type=style&index=0&id=06a516d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a516d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VForm,VSimpleTable,VTextField})
